import introduction from './01-introduction';
import pods from './02-pods';
import deployments from './03-deployments';

const tutorials = {
    1: introduction,
    2: pods,
    3: deployments
};

export { tutorials as default };